<div kalDialogContent>

    <app-shared-advanced-rule [formControl]="formControl"
                              [activityType]="activityType"
                              [isInterActivity]="data.isInterActivity"
                              [isPlanning]="data.isPlanning"
                              [ruleType]="data.ruleType"
                              [ruleId]="data.ruleId"
                              [isDuplicate]="data.isDuplicate"
                              [complementarySubvention]="data.complementarySubvention">
    </app-shared-advanced-rule>

</div>

<div kalDialogFooter>
    <kal-button (click)="save()"
                [disabled]="formControl?.invalid || loading"
                kalTheme="primary">
        Enregistrer
    </kal-button>

    <kal-button (click)="close()"
                kalTheme="secondary">
        Annuler
    </kal-button>

    <kal-button (click)="closeToSimpleMode()"
                *ngIf="shouldShowSwitchButton"
                [disabled]="loading"
                kalTheme="tertiary">
        Revenir au mode guidé
    </kal-button>

</div>
